var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bar-code 1",
    clipPath: "url(#clip0_38_717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.414 1.875H2.586C1.15997 1.875 0 3.03497 0 4.461V19.5234C0 20.9495 1.15997 22.1094 2.586 22.1094H21.414C22.84 22.1094 24 20.9495 24 19.5234V4.461C24 3.03497 22.84 1.875 21.414 1.875V1.875ZM22.5938 19.5234C22.5938 20.174 22.0646 20.7032 21.414 20.7032H2.586C1.93542 20.7032 1.40625 20.174 1.40625 19.5234V4.461C1.40625 3.81042 1.93542 3.28125 2.586 3.28125H21.414C22.0646 3.28125 22.5938 3.81042 22.5938 4.461V19.5234Z",
    fill: "#2A3256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.5314 5.64075H4.46875C4.08057 5.64075 3.76562 5.95551 3.76562 6.34387C3.76562 6.73206 4.08057 7.047 4.46875 7.047H19.5314C19.9196 7.047 20.2345 6.73206 20.2345 6.34387C20.2345 5.95551 19.9196 5.64075 19.5314 5.64075Z",
    fill: "#2A3256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.22168 9.40631C4.8335 9.40631 4.51855 9.72107 4.51855 10.1094V17.6407C4.51855 18.0289 4.8335 18.3439 5.22168 18.3439C5.61005 18.3439 5.9248 18.0289 5.9248 17.6407V10.1094C5.9248 9.72107 5.61005 9.40631 5.22168 9.40631Z",
    fill: "#2A3256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12 9.40631C11.6116 9.40631 11.2969 9.72107 11.2969 10.1094V17.6407C11.2969 18.0289 11.6116 18.3439 12 18.3439C12.3884 18.3439 12.7031 18.0289 12.7031 17.6407V10.1094C12.7031 9.72107 12.3884 9.40631 12 9.40631Z",
    fill: "#2A3256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M18.7783 9.40631C18.39 9.40631 18.0752 9.72107 18.0752 10.1094V17.6407C18.0752 18.0289 18.39 18.3439 18.7783 18.3439C19.1665 18.3439 19.4814 18.0289 19.4814 17.6407V10.1094C19.4814 9.72107 19.1665 9.40631 18.7783 9.40631Z",
    fill: "#2A3256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.98749 9.40631H8.23437C7.84601 9.40631 7.53125 9.72107 7.53125 10.1094V17.6407C7.53125 18.0289 7.84601 18.3439 8.23437 18.3439H8.98749C9.37567 18.3439 9.69061 18.0289 9.69061 17.6407V10.1094C9.69061 9.72107 9.37585 9.40631 8.98749 9.40631Z",
    fill: "#2A3256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.7653 9.40631H15.0122C14.624 9.40631 14.3091 9.72107 14.3091 10.1094V17.6407C14.3091 18.0289 14.624 18.3439 15.0122 18.3439H15.7653C16.1537 18.3439 16.4684 18.0289 16.4684 17.6407V10.1094C16.4684 9.72107 16.1537 9.40631 15.7653 9.40631Z",
    fill: "#2A3256"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCode);
export default __webpack_public_path__ + "static/media/bar-code.01f161e9addc393def8402d90c00d7f5.svg";
export { ForwardRef as ReactComponent };